module.exports = __webpack_public_path__ + "static/img/service-09.9ecb9678.png";